export enum ControlMode {
  FREE,
  FLIGHT,
}
